import { getComponentValue } from "./componentListRules";

export function mapComponentsForSubmit(componentList = []) {
  return componentList.map((component) => ({
    id: component.id,
    value: getComponentValue(component),
    uid: Number(component.uid ?? 0),
  }));
}

export function mapSubmitPayload(config, form, captchaVerification) {
  return {
    IsGasConsumerQuery: String(Boolean(config?.isGasConsumerQuery)),
    SystemType: config?.systemType || "",
    SystemIssueType: config?.systemIssueType || "",
    FirstName: form.firstNameQA.trim(),
    Surname: form.surnameQA.trim(),
    Email: form.emailQA.trim(),
    Phone: form.phoneQA.trim(),
    OrganisationId: form.organisationIdQA ?? "",
    OrganisationOther: form.otherOrganisationQA.trim(),
    Mprn: (form.mprnQA || "").trim(),
    Components: mapComponentsForSubmit(form.componentList),
    Files: form.filesQA,
    CaptchaVerification: captchaVerification,
  };
}
